import * as React from 'react';
import * as courseInvitation from '../styles/courseInvitation.module.scss';

export const CourseInvitation = () => {
  return (
    <section className={courseInvitation.courseInvitation}>
      <div className={'container'}>
        <div className={courseInvitation.courseInvitation__wrapper}>
          <div className={courseInvitation.courseInvitation__confetti}>
            <h2 className={courseInvitation.courseInvitation__title}>
              Пройдите онлайн-курс
              <br />
              <div className={courseInvitation.courseInvitation__selection}>«Английская лексика для детей»!</div>
            </h2>
          </div>
          <div>
            <h3 className={courseInvitation.courseInvitation__subtitle}>Вашему ребёнку понравится, потому что:</h3>
            <div className={courseInvitation.courseInvitation__cards}>
              <div
                className={`${courseInvitation.courseInvitation__card} ${courseInvitation.courseInvitation__cardOne}`}
              >
                <p className={courseInvitation.courseInvitation__text}>
                  <b>
                    Курс построен
                    <br />
                    на игровом сценарии,
                  </b>
                  <br />
                  развивает визуальное
                  <br />
                  мышление и воображение
                </p>
              </div>
              <div
                className={`${courseInvitation.courseInvitation__card} ${courseInvitation.courseInvitation__cardTwo}`}
              >
                <p className={courseInvitation.courseInvitation__text}>
                  <b>Все слова озвучены,</b>
                  <br />
                  снабжены переводом
                  <br />и транскрипцией
                </p>
              </div>
              <div
                className={`${courseInvitation.courseInvitation__card} ${courseInvitation.courseInvitation__cardThree}`}
              >
                <p className={courseInvitation.courseInvitation__text}>
                  <b>
                    Ребёнок сможет
                    <br />
                    легко запоминать
                    <br />
                    новую информацию
                  </b>
                  <br />
                  за пределами курса,
                  <br />
                  которая сохранится у него
                  <br /> в памяти на всю жизнь
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
